export default __webpack_public_path__ + "static/frame-2-hero-dccfcb404323390e81c03af6c2cc4cac.mp4";